<div class="ngx-gallery-icon" [class.ngx-gallery-icon-disabled]="disabled"
aria-hidden="true"
title="{{ titleText }}"
(click)="handleClick($event)">
    <i class="ngx-gallery-icon-content {{ icon }}"></i>
</div>